import React from 'react';
import Image from 'next/image';

import styles from './styles.module.scss';

const CellData = ({
  data: {
    left_icon: leftIcon,
    left_heading: leftHeading,
    right_heading: rightHeading,
    left_text: leftText,
    right_text: rightText,
    icons,
  },
}) => {
  // const renderList = ({ title = '', value = '', media }, key) => (
  //   <li key={key}>
  //     <div className={styles.info}>
  //       {title && <div className={styles.title}>{title}</div>}
  //       {value && <div className={styles.text}>{value}</div>}
  //     </div>
  //     <span className={styles.icons}>
  //       {media?.instagram && <Instagram />}
  //       {media?.whatsapp && <Whatsapp />}
  //       {media?.facebook && <Facebook />}
  //     </span>
  //   </li>
  // );

  return (
    <div
      className={styles.cell}
      itemScope
      itemType='https://schema.org/Article'
    >
      {leftIcon && (
        <div className={styles.icon_container}>
          <Image
            src={leftIcon}
            alt='leftIcon'
            title='leftIcon'
            loading='lazy'
            width={24}
            height={24}
          />
        </div>
      )}
      {/* <ul>{!!list.length && list.map(renderList)}</ul> */}
      <div className={styles.info}>
        {leftHeading && <div className={styles.title}>{leftHeading}</div>}
        {leftText && <div className={styles.text}>{leftText}</div>}
      </div>
      {rightText && (
        <div className={styles.info}>
          {leftHeading && <div className={styles.title}>{rightHeading}</div>}
          {leftText && <div className={styles.text}>{rightText}</div>}
        </div>
      )}
      <span className={styles.icons}>
        {icons?.length > 0 &&
          icons.map((icon) => (
            <Image
              key={icon}
              src={icon}
              alt='card icon'
              title='card icon'
              loading='lazy'
              width={24}
              height={24}
            />
          ))}
      </span>
    </div>
  );
};

export default CellData;
